import { io, type Socket } from 'socket.io-client';
import { getAccessToken } from './api';

const WS_URL = import.meta.env.VITE_WS_URL ?? '';

let socket: Socket | null = null;

export function getSocket(): Socket {
  if (socket && socket.connected) return socket;
  socket = io(WS_URL || undefined, {
    path: '/socket.io',
    withCredentials: true,
    transports: ['websocket', 'polling'],
    auth: (cb) => {
      const token = getAccessToken();
      cb(token ? { token } : {});
    },
  });
  return socket;
}

export function disconnectSocket() {
  socket?.disconnect();
  socket = null;
}
